import { __awaiter } from "tslib";
import { WritableStream } from "@yume-chan/adb";
import { PromiseResolver } from "@yume-chan/async";
import { AndroidCodecLevel, AndroidCodecProfile } from "../../codec.js";
import { createTinyH264Wrapper } from "./wrapper.js";
let cachedInitializePromise;
function initialize() {
    if (!cachedInitializePromise) {
        cachedInitializePromise = Promise.all([import('yuv-buffer'), import('yuv-canvas')]).then(([YuvBuffer, { default: YuvCanvas }]) => ({
            YuvBuffer, YuvCanvas
        }));
    }
    return cachedInitializePromise;
}
export class TinyH264Decoder {
    constructor() {
        this.maxProfile = AndroidCodecProfile.Baseline;
        this.maxLevel = AndroidCodecLevel.Level4;
        this._frameRendered = 0;
        initialize();
        this._renderer = document.createElement('canvas');
        this._writable = new WritableStream({
            write: (packet) => __awaiter(this, void 0, void 0, function* () {
                switch (packet.type) {
                    case 'configuration':
                        this.configure(packet.data);
                        break;
                    case 'frame':
                        if (!this._initializer) {
                            throw new Error('Decoder not initialized');
                        }
                        const wrapper = yield this._initializer.promise;
                        wrapper.feed(packet.data.slice().buffer);
                        break;
                }
            })
        });
    }
    get renderer() { return this._renderer; }
    get frameRendered() { return this._frameRendered; }
    get writable() { return this._writable; }
    configure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.dispose();
            this._initializer = new PromiseResolver();
            const { YuvBuffer, YuvCanvas } = yield initialize();
            if (!this._yuvCanvas) {
                this._yuvCanvas = YuvCanvas.attach(this._renderer);
                ;
            }
            const { encodedWidth, encodedHeight } = config;
            const chromaWidth = encodedWidth / 2;
            const chromaHeight = encodedHeight / 2;
            this._renderer.width = config.croppedWidth;
            this._renderer.height = config.croppedHeight;
            const format = YuvBuffer.format({
                width: encodedWidth,
                height: encodedHeight,
                chromaWidth,
                chromaHeight,
                cropLeft: config.cropLeft,
                cropTop: config.cropTop,
                cropWidth: config.croppedWidth,
                cropHeight: config.croppedHeight,
                displayWidth: config.croppedWidth,
                displayHeight: config.croppedHeight,
            });
            const wrapper = yield createTinyH264Wrapper();
            this._initializer.resolve(wrapper);
            const uPlaneOffset = encodedWidth * encodedHeight;
            const vPlaneOffset = uPlaneOffset + chromaWidth * chromaHeight;
            wrapper.onPictureReady(({ data }) => {
                this._frameRendered += 1;
                const array = new Uint8Array(data);
                const frame = YuvBuffer.frame(format, YuvBuffer.lumaPlane(format, array, encodedWidth, 0), YuvBuffer.chromaPlane(format, array, chromaWidth, uPlaneOffset), YuvBuffer.chromaPlane(format, array, chromaWidth, vPlaneOffset));
                this._yuvCanvas.drawFrame(frame);
            });
        });
    }
    dispose() {
        var _a;
        (_a = this._initializer) === null || _a === void 0 ? void 0 : _a.promise.then(wrapper => wrapper.dispose());
        this._initializer = undefined;
    }
}
//# sourceMappingURL=index.js.map